import { render, staticRenderFns } from "./CurdTable.vue?vue&type=template&id=fd1e6b14&"
import script from "./CurdTable.vue?vue&type=script&lang=js&"
export * from "./CurdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports